// possibly add TopLeft, TopCenter, TopRight, etc.
export type Alignment =
    'Left' |
    'Center' |
    'Right';

export class Alignments {
    public static readonly LEFT: Alignment = 'Left';
    public static readonly CENTER: Alignment = 'Center';
    public static readonly RIGHT: Alignment = 'Right';
}

export type ImageAlignment =
    'Left' |
    'Background' |
    'Right';

export class ImageAlignments {
    public static readonly LEFT: ImageAlignment = 'Left';
    public static readonly BACKGROUND: ImageAlignment = 'Background';
    public static readonly RIGHT: ImageAlignment = 'Right';
}